import {
  GroupedTotalDataType,
  KlassesGroupedType,
  RowGroupedData,
} from 'app/dataTypes/reports/data/common/subsidies/grouped'

import { createDynamicCountSumKey } from './create-column-keys'
import { Entity } from './types'

type CommonCell = {
  columnKey: string
  value: string
}

const createDefaultMainCells = (columnKeysMain: Array<string>) => {
  return columnKeysMain.reduce(
    (acc, key) => {
      acc[key] = {
        columnKey: key,
        value: '0',
      }
      return acc
    },
    {} as Record<string, CommonCell>,
  )
}

const createClassTypeCells = (
  items: Array<KlassesGroupedType>,
  classType: 'dayCares' | 'klasses',
) => {
  return items.reduce(
    (acc, { title, count, sum }) => {
      const countKey = createDynamicCountSumKey(classType, title, 'count')
      const sumKey = createDynamicCountSumKey(classType, title, 'sum')

      acc[countKey] = {
        columnKey: countKey,
        value: String(count),
      }
      acc[sumKey] = {
        columnKey: sumKey,
        value: sum || '0',
      }

      return acc
    },
    {} as Record<string, CommonCell>,
  )
}

const createRowData = (
  {
    dayCares,
    klasses,
    count,
    sum,
  }: Pick<RowGroupedData, 'dayCares' | 'klasses' | 'count' | 'sum'>,
  columnKeysMain: Array<string>,
  dateValue: string,
) => {
  return {
    ...createDefaultMainCells(columnKeysMain),
    ...createClassTypeCells(dayCares, 'dayCares'),
    ...createClassTypeCells(klasses, 'klasses'),
    [Entity.Date]: {
      columnKey: Entity.Date as const,
      value: dateValue,
    },
    [Entity.CountRow]: {
      columnKey: Entity.CountRow as const,
      value: String(count),
    },
    [Entity.SumRow]: {
      columnKey: Entity.SumRow as const,
      value: sum || '0',
    },
  }
}

export const createData = (data: Array<RowGroupedData>, columnKeysMain: Array<string>) => {
  return data.map((row) => ({
    rowKey: row.date.getString('YYYY-MM-DD'),
    rowData: createRowData(row, columnKeysMain, row.date.getString('DD.MM.YYYY')),
  }))
}

export const createTotalData = (
  total: GroupedTotalDataType,
  columnKeysMain: Array<string>,
) => {
  return [
    {
      rowKey: 'total',
      rowData: createRowData(total, columnKeysMain, 'Всего'),
    },
  ]
}
